import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_277: DocMigration = {
  maxSchemaVersion: "0.0.277",
  description: "Migrate gable openings to roofSideOverrides",
  apply(json: any): any {
    for (const openingId in json.gableOpenings) {
      const opening = json.gableOpenings[openingId];

      if (!opening) {
        continue;
      }

      const { faces } = opening;

      if (!faces || faces === "ALL" || faces === "FRONT_AND_BACK") {
        opening.side = "START";
        delete opening.faces;
        const newOpeningId = uid();
        //since we are splitting they can have the same sort index as they will always be sorted separately
        json.gableOpenings[newOpeningId] = { ...opening, id: newOpeningId, side: "END" };
      } else if (faces === "FRONT") {
        opening.side = "START";
        delete opening.faces;
      } else if (faces === "BACK") {
        opening.side = "END";
        delete opening.faces;
      } else {
        delete json.gableOpenings[openingId];
      }
    }
    return json;
  },
};

export default migration_0_0_277;
